import * as React from "react";
import {connect} from "react-redux";
import {option, Option} from "ts-option";
import {RootState} from "../../../store/reducer/root/RootState";
import Job from "../../../model/job/Job";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import JobType from "../../../model/job/JobType";

interface ComponentProps {
	/**
	 * Job.
	 */
	job: Option<Job>
}

interface ReduxProps {
	/**
	 * Job types.
	 */
	jobTypes: JobType[];
}


type Props = ComponentProps & ReduxProps

class JobTypeDisplayer extends React.PureComponent<Props> {
	render() {
		const jobType = this.props.job.flatMap(j => option(this.props.jobTypes.filter(jt => jt.id == j.data.jobTypeId)[0]));
		const jobTypeName = jobType.map(jt => jt.name).getOrElse("Not specified");
		return (
			<InfoModule icon={Icon.Job} title={"Job type"}>
				<span className="t-body">{jobTypeName}</span>
			</InfoModule>
		);
	}

}

function mapStateToProps(state: RootState) {
	return {
		jobTypes: state.jobType.jobTypes.getOrElse([])
	}
}

export default connect(mapStateToProps)(JobTypeDisplayer)